import AssetItem from './AssetItem';

export default AssetItem;
